var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { VendorBrandMapping } from './Constants';
export var brandMapping = function (vendor, brandList) {
    var vendorBrandMapping = VendorBrandMapping[vendor];
    if (!vendorBrandMapping) {
        throw new Error('Unsupported vendor brand mapping.');
    }
    return brandList.reduce(function (prev, curr) {
        if (vendorBrandMapping[curr]) {
            return __spreadArray(__spreadArray([], prev, true), [vendorBrandMapping[curr]], false);
        }
        return prev;
    }, []);
};
